module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAYAAACqj0o2AAAArklEQVR4nO3QsQ3AIADAMP6/rDMzv7RHgERUecgeeTxzvdpr3B74QxAhNoIIsRFEiI0gQmwEEWIjiBAbQYTYCCLERhAhNoIIsRFEiI0gQmwEEWIjiBAbQYTYCCLERhAhNoIIsRFEiI0gQmwEEWIjiBAbQYTYCCLERhAhNoIIsRFEiI0gQmwEEWIjiBAbQYTYCCLERhAhNoIIsRFEiI0gQmwEEWIjiBAbQYTYCOKBPjLDnr6Sj4cdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/6_1_touxiang.png
// module id = S2VF
// module chunks = 1